import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModalToast, NULL_MODAL_TOAST, ToasterService, ToastType } from 'src/app/services/toaster.service';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
    selector: 'lib-banner-modal',
    templateUrl: './banner-modal.component.html',
    standalone: true,
    styleUrl:'./banner-modal.component.css',
    imports: [CommonModule, TranslocoPipe]
})
export class ModalBannerComponent implements OnInit {
    nullModal = NULL_MODAL_TOAST
    public modal: ModalToast = NULL_MODAL_TOAST;
    public imageUri = ""
    type=ToastType 

    constructor(private toaster: ToasterService) {}

    ngOnInit(): void {
        this.toaster.removeModal();
        this.toaster.modalToast$.subscribe(modal => {
            switch(modal.type){
                case ToastType.Error:
                    this.imageUri= "../../../assets/img/failed-circle.svg";
                    break;
                case ToastType.Success:
                    this.imageUri= "../../../assets/img/success_circle.svg";
                    break;
            }
            this.modal = modal;
        });
    }

    close(): void {
        this.modal = this.nullModal;
    }
}
